<script>
import { Line } from 'vue-chartjs';


const CHART_OPTIONS = {
  title: {
    display: true,
    position: 'bottom',
    text: 'Consommation de vin',
    fontColor: 'white'
  },
  legend: {
    display: false
  },
  scales: {
    xAxes: [
      {
        ticks: {
          fontColor: 'white'
        }
      }
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          fontColor: 'white',
          labelString: 'Volume (L)'
        },
        ticks: {
          fontColor: 'white',
          min: 0
        }
      }
    ]
  },
  tooltips: {
    callbacks: {
      label (tooltipItem, data) {
        var label = data.datasets[tooltipItem.datasetIndex].label || '';

        if (label) {
          label += ': ';
        }
        label += `${Math.round(tooltipItem.yLabel * 100) / 100} L`;
        return label;
      }
    }
  }
};


export default {
  name: 'WineConsumptionChart',
  extends: Line,

  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: Object,
    xLabel: String
  },

  watch: {
    'chartData': function () {
      this.update();
    }
  },

  mounted () {
    this.update();
  },

  methods: {
    update () {
      const options = Object.assign({}, CHART_OPTIONS, this.options);
      if (this.xLabel) {
        options.scales.xAxes[0].scaleLabel = {
          display: true,
          fontColor: 'white',
          labelString: this.xLabel
        };
      }

      this.renderChart(this.chartData, options);
    }
  }
};
</script>
